import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';
import PricingSection from '../components/PricingSection';
import { useAuth } from '../context/AuthContext';

/**
 * Standalone /pricing page — reused from upgrade CTAs throughout the app.
 */
export default function PricingPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    return (
        <div
            className="min-h-screen"
            style={{ background: 'linear-gradient(160deg, #EEE7FF 0%, #F5F0FF 45%, #F0E9FF 100%)' }}
        >
            {/* Header */}
            <header className="relative z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-20">
                        <Link to={user ? '/dashboard' : '/'} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                            <div className="w-10 h-10 rounded-xl bg-[#7C3AED] flex items-center justify-center shadow-sm">
                                <BookOpen className="w-5 h-5 text-white" strokeWidth={2.5} />
                            </div>
                            <span className="text-xl font-black text-zinc-950 tracking-tight">A-Level AI Grader</span>
                        </Link>
                        <button
                            onClick={() => navigate(user ? '/dashboard' : '/')}
                            className="inline-flex items-center gap-2 text-sm font-bold text-zinc-700 hover:text-[#7C3AED]"
                            data-testid="pricing-back"
                        >
                            <ArrowLeft className="w-4 h-4" /> Back
                        </button>
                    </div>
                </div>
            </header>

            <PricingSection defaultRole={user?.role === 'teacher' ? 'teacher' : 'student'} />
        </div>
    );
}
